<template>
	<div
		:id="idContainer"
		class="container__tooltip"
	>
		<i
			class="container__tooltip__icon fas fa-question-circle"
			@mouseenter="ajustarPosicao"
		/>
		<div
			:id="idBalao"
			class="container__tooltip__balloon"
		>
			<div class="container__tooltip_balloon__header">
				<p>{{ titulo }}</p>
				<p>{{ subtitulo }}</p>
			</div>
			<div class="container__tooltip__balloon__content">
				<span v-html="conteudo" />
			</div>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
	props: {
		// Titulo Tooltip
		titulo: {
			type: String,
			require: true,
		},
		// Subtitulo Tooltip
		subtitulo: {
			type: String,
		},
		// Conteudo Tooltip
		conteudo: {
			type: String,
			require: true,
		},
	},
	computed: {
		// Id do container
		idContainer() {
			return `id_container_${uuidv4()}`
		},
		// Id do balao
		idBalao() {
			return `id_balao_${uuidv4()}`
		},
	},
	methods: {
		/**
		 * Ajusta a posicao do tooltip de acordo com o tamanho da tela, se a tela
		 * Se a tela for menor que 768 o tooltip fica fixo na parte de baixo do dispositivo
		 * Se a tela for maior é necessário posicionar o elemento de forma que nao saia para fora da tela considerando a posicao vertical e horizontal
		 */
		ajustarPosicao() {
			const larguraDaTela = window.innerWidth
			const elementoBalao = document.getElementById(this.idBalao)

			// Volta o estilo para unset no top
			if (larguraDaTela < 768) {
				elementoBalao.style.top = 'unset'
				elementoBalao.style.marginLeft = 'calc(-90vw / 2)'
				return
			}

			// Recupera a posicao do container e do balao de tooltip
			const posicaoContainer = document.getElementById(this.idContainer).getBoundingClientRect()
			const posicaoBalao = elementoBalao.getBoundingClientRect()

			const DISTANCIA_ENTRE_BALAO_E_ICONE = 30

			// Recupera a altura da tela para definir se o balao deve ser exibido em cima ou embaixo do icone de "?" (ALINHAMENTO VERTICAL)
			const alturaDaTela = window.innerHeight
			if (posicaoContainer.y > alturaDaTela / 2) {
				const distanciaCalculada = (posicaoBalao.height + DISTANCIA_ENTRE_BALAO_E_ICONE - 19.2) * -1
				elementoBalao.style.top = `${distanciaCalculada}px`
			} else {
				elementoBalao.style.top = `${DISTANCIA_ENTRE_BALAO_E_ICONE}px`
			}

			// Ajusta o balao para quando ele estiver muito proximo das bordas da tela (ALINHAMENTO HORIZONTAL)
			if (posicaoContainer.x > larguraDaTela / 2) {
				if (posicaoContainer.x + posicaoBalao.width / 2 > larguraDaTela) {
					const marginLeft = (posicaoContainer.x + posicaoBalao.width - larguraDaTela) * 1.3
					elementoBalao.style.marginLeft = `-${marginLeft}px`
				}
			} else {
				if (posicaoBalao.x < 0) {
					elementoBalao.style.marginLeft = `${posicaoBalao.x}px`
				}
			}
		},
	},
}
</script>

<style scoped>
p {
	margin: 0;
}

.container__tooltip {
	padding: 0;
}

.container__tooltip__icon {
	font-size: 1rem;
	color: rgb(var(--color-primary), 0.2);
}

.container__tooltip__icon:hover {
	color: rgb(var(--color-primary), 0.5);
}

.container__tooltip__icon:hover + .container__tooltip__balloon {
	visibility: visible;
	opacity: 1;
}

.container__tooltip__balloon {
	visibility: hidden;
	position: fixed;
	width: 90vw;
	left: 50%;
	margin-left: calc(-90vw / 2);
	border-radius: 5px;
	color: rgb(var(--color-primary));
	background: transparent;
	background: #f1f1f1;
	overflow: auto;
	bottom: 3rem;
	z-index: 100;
	opacity: 0;
	transition:
		visibility 0s,
		opacity 1s;
}

.container__tooltip_balloon__header {
	background-color: rgb(var(--color-primary));
	padding: 0.7rem 1rem;
	font-size: 0.8rem;
	text-align: left;
}

.container__tooltip_balloon__header p:nth-child(1) {
	color: rgb(var(--color-default));
	font-weight: 700;
	text-transform: uppercase;
}

.container__tooltip_balloon__header p:nth-child(2) {
	color: white;
	font-size: 0.7rem;
	font-weight: 500;
}

.container__tooltip__balloon__content {
	padding: 0.7rem 1rem;
	border: 1px solid rgb(var(--color-primary));
	text-align: left;
	font-weight: normal;
}

@media screen and (min-width: 768px) {
	.container__tooltip {
		position: relative;
	}

	.container__tooltip__balloon {
		position: absolute;
		width: 40vw;
		margin-left: calc(-40vw / 2);
		bottom: unset;
	}
}

@media screen and (min-width: 1200px) {
	.container__tooltip__balloon {
		width: 20vw;
		margin-left: calc(-20vw / 2);
	}
}
</style>
